import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press12',
  templateUrl: './notice-press12.component.html',
  styleUrls: ['./notice-press12.component.scss']
})
export class NoticePress12Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
